import Container from '@/components/base/Container'
import Grid from '@/components/base/Grid'
import Motion from '@/components/base/Motion'
import Pillar, { PillarProps } from '@/components/base/Pillar'

import { pillarsGridRevealAnimation } from './animations'
import { Section } from '@/types'

type PillarsGridIconProps = Section & {
  rep_collection?: PillarProps[]
}

const PillarsGridIcon = ({
  rep_collection,
  ...props
}: PillarsGridIconProps) => {
  return (
    <Motion animation={pillarsGridRevealAnimation}>
      {(motionRef) => (
        <section ref={motionRef} {...props}>
          <Container>
            <Grid className="gap-y-xs md:gap-y-sm">
              {rep_collection?.map((pillar, index) => (
                <div
                  key={`pillar-${index}`}
                  className="col-span-2 sm:col-span-1 md:col-span-4 lg:col-span-4"
                >
                  <Pillar {...pillar} />
                </div>
              ))}
            </Grid>
          </Container>
        </section>
      )}
    </Motion>
  )
}

export default PillarsGridIcon
